<template>
  <table>
    <thead>
      <tr>
        <th class="text-center" :colspan="colspan">
          Recently Added Films
        </th>
      </tr>
      <tr>
        <th>Released</th>
        <th>Title</th>
        <th>Director</th>
        <th>Runtime</th>
        <th class="text-center">Rating</th>
        <th class="text-center">Watched</th>
        <th class="text-center">Owned</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(film, index) in films" :key="film.id">
        <td>
          <router-link :to="links.dateLink(film.release_date)">
            {{ film.release_date }}
          </router-link>
        </td>
        <td>
          <router-link :to="links.filmLink(film)">
            {{ film.title }}
          </router-link>
        </td>
        <td><chip-group :values="film.directors" query="person" /></td>
        <td>{{ utils.runtimeText(film) }} </td>
        <td class="text-center">
          <film-rating :id="film.id" :rating="film.avg_rating" />
        </td>
        <td class="text-center">
          <my-rating
            :id="film.id"
            :rating="utils.userRating(film, me.id)"
            @updateFilm="updateFilm(index, $event)"
          />
        </td>
        <td class="text-center">
          <film-ownership
            :id="film.id"
            :owned="film.owned"
            @updateFilm="updateFilm(index, $event)"
          />
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td :colspan="colspan">
          <v-pagination
            :length="Math.ceil(count/pageSize)"
            :total-visible="12"
            :value="page"
            @input="loadPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import links from "@/utils/Links"
import utils from "@/utils/utils"
import FilmRating from "@/components/details/FilmRating"
import MyRating from "@/components/details/MyRating"
import ChipGroup from "@/components/details/ChipGroup"
import FilmOwnership from "@/components/details/FilmOwnership"

export default {
  name: "RecentFilms",
  components: {
    FilmRating,
    MyRating,
    ChipGroup,
    FilmOwnership,
  },
  data() {
    return {
      films: [],
      count: 0,
      page: 0,
    }
  },
  inject: ["httpClient"],
  mounted() {
    this.loadPage(1)
  },
  computed: {
    me() {
      return this.$store.state.me
    },
    // TODO: better way to inject?
    links() {
      return links
    },
    utils() {
      return utils
    },
    // TODO: change to global config
    pageSize() {
      return 10
    },
    colspan() {
      return 7
    },
  },
  methods: {
    async loadPage(page) {
      const data = await this.httpClient.loadFilms({
        page,
        query: {annotate_rating: this.me.id}
      })
      this.films = data.results
      this.page = data.page
      this.count = data.count
    },
    updateFilm(index, data) {
      const film = Object.assign(this.films[index], data)
      this.films.splice(index, 1, film)
    },
  },
}
</script>
